import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "at-email-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: 1.05 },
        React.createElement("path", { strokeLinecap: "round", d: "M10.5 5v3c0 2.917 1.25 3.5 2.5 3.5s2-1.5 2-3c0-3.866-2.634-7-6.5-7a7 7 0 1 0 2.109 13.677" }),
        React.createElement("path", { d: "M8 11.5c1.389 0 2.5-1.343 2.5-3s-1.111-3-2.5-3-2.5 1.343-2.5 3 1.111 3 2.5 3Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
